import { CommonModule } from '@angular/common';
import { RouterModule } from '@angular/router';
import { NgModule } from '@angular/core';
import { FormsModule } from '@angular/forms';

import { PdfViewerModule } from 'ng2-pdf-viewer';
import { NgxDropzoneModule } from 'ngx-dropzone';
import { NgChartsModule } from 'ng2-charts';
import { NgxEchartsModule } from 'ngx-echarts';
import { GoogleMapsModule } from '@angular/google-maps';

import { AntdModule } from 'src/app/antd.module';

import { TuainNgFormsLibModule } from 'tuain-ng-forms-lib';
import { CustomComponentsModule } from '../custom/custom-component.module';

import { AppSectionComponent } from './layout/section/app-section.component';
import { AppSubSectionComponent } from './layout/section/app-subsection.component';
import { AppElementComponent } from './layout/element/app-element.component';
import { AppFormHeaderComponent } from './layout/header/app-form-header.component';
import { AppFormErrorComponent } from './layout/error-header/app-form-error.component';

import { AppFieldComponent } from './fields/app-field/app-field.component';
import { AppLabelComponent } from './fields/static/app-label.component';
import { AppWarningComponent } from './fields/static/app-warning.component';
import { AppTextHtmlComponent } from './fields/static/app-text-html.component';
import { AppMessageComponent } from './fields/static/app-message.component';
import { AppLinkComponent } from './fields/static/app-link.component';
import { AppInputComponent } from './fields/input/app-input.component';
import { AppInputSearchComponent } from './fields/input-search/app-input-search.component';
import { AppEmailComponent } from './fields/email/app-email.component';
import { AppNumberComponent } from './fields/number/app-number.component';
import { AppTextNumberComponent } from './fields/text-number/app-text-number.component';
import { AppPhoneComponent } from './fields/phone/app-phone.component';
import { AppCiiuComponent } from './fields/ciiu/app-ciiu.component';
import { AppCityComponent } from './fields/city/app-city.component';
import { AppCountryComponent } from './fields/country/app-country.component';
import { AppPasswordComponent } from './fields/password/app-password.component';
import { AppRadioComponent } from './fields/radio/app-radio.component';
import { AppSelectComponent } from './fields/select/app-select.component';
import { AppTypeAheadComponent } from './fields/typeahead/app-typeahead.component';
import { AppArrayComponent } from './fields/array/app-array.component';
import { AppDateComponent } from './fields/date/app-date.component';
import { AppYearMonthComponent } from './fields/yearmonth/app-yearmonth.component';
import { AppDateRangeComponent } from './fields/date-range/app-date-range.component';
import { AppImageComponent } from './fields/image/app-image.component';
import { AppPdfComponent } from './fields/pdf-viewer/app-pdf-viewer.component';
import { AppTextAreaComponent } from './fields/textarea/app-textarea.component';
import { AppTimeComponent } from './fields/time/app-time.component';
import { AppTimeRangeComponent } from './fields/time-range/app-time-range.component';
import { AppTimeRangeSliderComponent } from './fields/time-range-slider/app-time-range-slider.component';
import { AppCheckComponent } from './fields/check/app-check.component';
import { AppAvatarComponent } from './fields/avatar/app-avatar.component';
import { AppMapComponent } from './fields/map/app-map.component';
import { AppGeoCoderComponent } from './fields/geo-coder/app-geo-coder.component';
import { AppProgressComponent } from './fields/progress/app-progress.component';

import { AppActionComponent } from './actions/app-action.component';

import { AppTableComponent } from './tables/app-table/app-table.component';
import { AppChartTableComponent } from './tables/chart-table/app-chart-table.component';
import { AppEChartTableComponent } from './tables/echart-table/app-echart-table.component';
import { AppGridTableComponent } from './tables/grid-table/app-grid-table.component';
import { AppTableRecordFieldComponent } from './tables/fields/row-field.component';
import { AppTableRecordActionComponent } from './tables/actions/row-action.component';
import { AppMapTableComponent } from './tables/map-table/app-map-table.component';
import { AppPieTableComponent } from './tables/pie-table/app-pie-table.component';

import { StandardModalComponent, UploadModalComponent } from './forms/modals/standard-modals.component';

import { AppFormComponent } from './forms/app-form.component';

const COMPONENTS = [
  AppSectionComponent,
  AppSubSectionComponent,
  AppElementComponent,
  AppFieldComponent,
  AppLabelComponent,
  AppWarningComponent,
  AppTextHtmlComponent,
  AppMessageComponent,
  AppLinkComponent,
  AppInputComponent,
  AppInputSearchComponent,
  AppEmailComponent,
  AppNumberComponent,
  AppTextNumberComponent,
  AppPhoneComponent,
  AppCiiuComponent,
  AppCityComponent,
  AppCountryComponent,
  AppPasswordComponent,
  AppSelectComponent,
  AppRadioComponent,
  AppTypeAheadComponent,
  AppArrayComponent,
  AppDateComponent,
  AppYearMonthComponent,
  AppDateRangeComponent,
  AppImageComponent,
  AppPdfComponent,
  AppTextAreaComponent,
  AppTimeComponent,
  AppTimeRangeComponent,
  AppTimeRangeSliderComponent,
  AppCheckComponent,
  AppActionComponent,
  AppFormHeaderComponent,
  AppFormErrorComponent,
  AppAvatarComponent,
  AppMapComponent,
  AppGeoCoderComponent,
  AppProgressComponent,
  AppTableComponent,
  AppChartTableComponent,
  AppEChartTableComponent,
  AppGridTableComponent,
  AppTableRecordFieldComponent,
  AppTableRecordActionComponent,
  AppMapTableComponent,
  AppPieTableComponent,
  StandardModalComponent,
  UploadModalComponent,
  AppFormComponent,
];

@NgModule({
  imports: [
    CommonModule,
    RouterModule,
    FormsModule,
    PdfViewerModule,
    AntdModule,
    NgxDropzoneModule,
    NgChartsModule,
    NgxEchartsModule.forRoot({ echarts: () => import('echarts') }),
    TuainNgFormsLibModule,
    CustomComponentsModule,
    GoogleMapsModule,
  ],
  declarations: COMPONENTS,
  exports: [TuainNgFormsLibModule, ...COMPONENTS],
  bootstrap: [],
  schemas: [],
})
export class TuainComponentsModule { }
